import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A6802
 *
 * @param {SvgIconProps} props - svg props
 */
export const AttachFileButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='12' cy='12' r='12' fill={color}/>
            <path d='M16.9525 11.4522L11.7777 16.627C10.7833 17.6214 9.0859 17.535 7.98472 16.4338C6.88354 15.3326 6.79709 13.6352 7.79154 12.6408L13.4163 7.01607C14.0372 6.3951 15.0993 6.44919 15.7869 7.13681C16.4745 7.82442 16.5286 8.88646 15.9076 9.50743L10.7329 14.6822C10.4854 14.9297 10.0587 14.9079 9.78463 14.6339C9.51058 14.3598 9.48884 13.9331 9.73633 13.6856L14.4611 8.96086L13.7137 8.21345L8.98892 12.9382C8.36795 13.5592 8.42205 14.6212 9.10966 15.3088C9.79728 15.9965 10.8593 16.0505 11.4803 15.4296L16.655 10.2548C17.6495 9.26039 17.563 7.56302 16.4618 6.46184C15.3607 5.36066 13.6633 5.27421 12.6688 6.26866L7.04413 11.8934C5.6762 13.2613 5.79501 15.594 7.30975 17.1087C8.8245 18.6235 11.1572 18.7423 12.5251 17.3744L17.6999 12.1996L16.9525 11.4522Z' fill='white'/>
        </SvgIcon>
    )
}

export default AttachFileButtonIcon
